import React from 'react';
import { useTranslation } from 'react-i18next';

import { EditReimbursementModalButtons } from './EditReimbursementModalButtons';
import { ModalContainer } from '../../../common';

import { useCareCreditCardSubmit } from './hooks/useCareCreditCardSubmit';

import styles from '../css/CareCreditAgreement.module.css';
import { doNothing } from '../../../../services/utils';

const CareCreditAgreement = ({
  cancelAll = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation('myAccount');
  const {
    loading,
    onSubmitCareCredit,
    updateSuccess,
  } = useCareCreditCardSubmit();

  return (
    <ModalContainer
      cancelable
      handleOutClick={loading ? doNothing : cancelAll}
      overlayClassName={styles.overlay}
      show
    >
      <div className={styles.container}>
        <h4 className={styles.contentTitle}>
          {t('reimbursementSection.careCredit.agreementTitle')}
        </h4>

        <p className={styles.content}>
          {t('reimbursementSection.careCredit.agreement')}
        </p>

        <EditReimbursementModalButtons
          customAcceptLabel={t('reimbursementSection.careCredit.agree')}
          finalStep
          handleEditReimbursementAccept={onSubmitCareCredit}
          handleEditReimbursementCancel={loading ? doNothing : onCancel}
          handleEditReimbursementSuccess={cancelAll}
          reimbursementMethodUpdateSuccess={updateSuccess}
          updatingReimbursementMethod={loading}
        />
      </div>
    </ModalContainer>
  );
};

export { CareCreditAgreement };
